import styled from 'styled-components';
import { getContrastColor } from '../../utils/colorUtils';

export const Title = styled.h2`
  text-align: center;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  margin-bottom: 20px;
  font-size: 24px;
`;

export const Description = styled.p`
  text-align: center;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  margin-bottom: 25px;
  font-size: 14px;
  line-height: 1.5;
  opacity: 0.9;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-weight: 600;
  font-size: 13px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 2px solid ${props => {
    const contrastColor = getContrastColor(props.bgColor || '#ffffff');
    return contrastColor === '#ffffff' ? '#444' : '#ddd';
  }};
  border-radius: 6px;
  font-size: 14px;
  background-color: ${props => {
    const contrastColor = getContrastColor(props.bgColor || '#ffffff');
    return contrastColor === '#ffffff' ? '#1a1a1a' : '#f8f9fa';
  }};
  color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#ffffff' : '#333'};
  transition: all 0.3s;
  font-family: inherit;

  &::placeholder {
    color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#999' : '#999'};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.accentColor || '#667eea'};
    background-color: ${props => {
      const contrastColor = getContrastColor(props.bgColor || '#ffffff');
      return contrastColor === '#ffffff' ? '#2a2a2a' : '#fff';
    }};
    box-shadow: 0 0 0 3px ${props => props.accentColor ? props.accentColor + '20' : 'rgba(102, 126, 234, 0.1)'};
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 2px solid ${props => {
    const contrastColor = getContrastColor(props.bgColor || '#ffffff');
    return contrastColor === '#ffffff' ? '#444' : '#ddd';
  }};
  border-radius: 6px;
  font-size: 14px;
  background-color: ${props => {
    const contrastColor = getContrastColor(props.bgColor || '#ffffff');
    return contrastColor === '#ffffff' ? '#1a1a1a' : '#f8f9fa';
  }};
  color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#ffffff' : '#333'};
  transition: all 0.3s;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;

  &::placeholder {
    color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#999' : '#999'};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.accentColor || '#667eea'};
    background-color: ${props => {
      const contrastColor = getContrastColor(props.bgColor || '#ffffff');
      return contrastColor === '#ffffff' ? '#2a2a2a' : '#fff';
    }};
    box-shadow: 0 0 0 3px ${props => props.accentColor ? props.accentColor + '20' : 'rgba(102, 126, 234, 0.1)'};
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px;
  background: ${props => props.accentColor || '#667eea'};
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px ${props => props.accentColor ? props.accentColor + '40' : 'rgba(102, 126, 234, 0.4)'};
  }

  &:disabled {
    opacity: 0.6;
  }
`;

export const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #c3e6cb;
  text-align: center;
  font-size: 14px;
`;

export const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #f5c6cb;
  text-align: center;
  font-size: 14px;
`;
